import React from "react";
import { InputGroup, InputLeftAddon, NumberInput, NumberInputField } from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import FieldFrame from "./FieldFrame";

const CurrencyField = ({ field, control, disabled, error, required, compact }) => (
  <Controller
    control={control}
    name={field.code}
    render={({ field: input }) => (
      <FieldFrame field={field} error={error} isRequired={required} compact={compact}>
        <InputGroup>
          <InputLeftAddon>{field.uiConfig?.currencySymbol || field.uiConfig?.currency || "¤"}</InputLeftAddon>
          <NumberInput
            value={input.value ?? ""}
            precision={field.uiConfig?.precision ?? 2}
            step={field.uiConfig?.step || 1}
            isDisabled={disabled}
            onChange={(_, valueAsNumber) => input.onChange(Number.isNaN(valueAsNumber) ? "" : valueAsNumber)}
          >
            <NumberInputField placeholder={field.placeholder} fontWeight={compact ? "semibold" : "normal"} />
          </NumberInput>
        </InputGroup>
      </FieldFrame>
    )}
  />
);

export default CurrencyField;
